import WarningAmberRoundedIcon from "@mui/icons-material/WarningAmberRounded";

const WarningAmberRounded = (props: any) => {
  return <WarningAmberRoundedIcon {...props} />;
};

export default WarningAmberRounded;
